// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3-vUU","upload":"Small_upload__3RamQ","imageWrap":"Small_imageWrap__1txly","removeBtn":"Small_removeBtn__3SN3K"};